/// <amd-module name="WorkItemsHub/Actions/ActionsHub" />
import { Action } from "VSS/Reflux/Action";
import { IWorkItemsHubUpdateData, IWorkItemsHubRemoveWorkItemData, IWorkItemsHubPagedWorkItemData } from 'DataContracts/IActionsDataContract';
import { IWorkItemsHubFilterUpdateData, IWorkItemsHubSortItemsData, IWorkItemsHubShowCompletedItemsData } from "WorkItemsHub/DataContracts/IActionsDataContract";

export class ActionsHub {
    public endRefreshDataProvider = new Action<IWorkItemsHubUpdateData>();
    public invalidateAllTabsData = new Action<{}>();
    public removeWorkItems = new Action<IWorkItemsHubRemoveWorkItemData>();
    public invalidateTabData = new Action<string>();
    public updateFilter = new Action<IWorkItemsHubFilterUpdateData>();
    public setCompletedItemsVisibility = new Action<IWorkItemsHubShowCompletedItemsData>();
    public sortItems = new Action<IWorkItemsHubSortItemsData>();
    public endPageWorkItems = new Action<IWorkItemsHubPagedWorkItemData>();
}
